class MFRHeroComponents {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {};

    this.maxBorderRadius = 30;
    this.minScale = 0.96;

    this.topTriggers = {
      start: "top 80%",
      end: "top 10%",
    };
    this.bottomTriggers = {
      start: "bottom 80%",
      end: "bottom 10%",
    };

    this.init();
  }

  init() {
    gsap.set(this.$element, {
      borderTopLeftRadius: this.maxBorderRadius,
      borderTopRightRadius: this.maxBorderRadius,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      scaleX: this.minScale,
    });

    gsap.fromTo(
      this.$element,
      {
        scaleX: 1,
      },
      {
        borderBottomLeftRadius: this.maxBorderRadius,
        borderBottomRightRadius: this.maxBorderRadius,
        scaleX: this.minScale,
        scrollTrigger: {
          trigger: this.$element,
          scrub: true,
          ...this.bottomTriggers,
        },
      }
    );

    gsap.fromTo(
      this.$element,
      {
        scaleX: this.minScale,
      },
      {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        scaleX: 1,
        scrollTrigger: {
          trigger: this.$element,
          scrub: true,
          ...this.topTriggers,
        },
      }
    );
  }
}
